export function formatRfpAnalysisDetailId(id: number): string {
  return `RA-${id}`;
}

export function truncateText(text: string | null, max = 80): string {
  if (!text) return "";
  const t = text.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}

export const RFP_ANALYSIS_STATUS_DRAFT = "DRAFT";
export const RFP_ANALYSIS_STATUS_OPEN = "OPEN";
export const RFP_ANALYSIS_STATUS_DELETED = "DELETED";
export const RFP_ANALYSIS_SOURCE_AI = "AI";
export const RFP_ANALYSIS_SOURCE_USER = "USER";
export const RFP_ANALYSIS_MODULE_GENERAL = "General";

/** PMS always accepts General, so it is listed first even when no detail uses it yet. */
export function listRfpAnalysisModules(names: readonly string[]): string[] {
  const modules = new Set<string>([RFP_ANALYSIS_MODULE_GENERAL]);
  for (const name of names) {
    if (name?.trim()) modules.add(name);
  }
  return [...modules].sort((a, b) => {
    if (a === RFP_ANALYSIS_MODULE_GENERAL) return -1;
    if (b === RFP_ANALYSIS_MODULE_GENERAL) return 1;
    return a.localeCompare(b);
  });
}
